<template>
  <div>
    <draggable v-model="fileList" style="display: inline-block">
      <!-- 遍历图片列表 -->
      <div class="uploadImgList-single" v-for="img in fileList" :key="img.resourceId">
        <a :href="img.url" target="_blank">
          <div class="img-cover" :style="{backgroundImage:'url(' + img.url + ')'}"></div>
        </a>
        <i class="el-icon-delete" @click="handleRemove(img)"
           style="position: absolute; top: 5px; right: 5px; font-size: 18px; cursor: pointer; color: #f56c6c;">
        </i>
<!--        &lt;!&ndash; 图片 &ndash;&gt;-->
<!--        <img class="uploadImgList-img" :src="img.url">-->
<!--        &lt;!&ndash; 删除图标 &ndash;&gt;-->

      </div>
    </draggable>
    <!-- 上传按钮 -->
    <el-upload
      class="upload-button"
      :action="uploadUrl"
      list-type="picture-card"
      :show-file-list="false"
      :on-preview="handlePictureCardPreview"
      :on-success="handleSuccess"
      :data="paramsObj"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="预览图片">
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getToken } from '@/utils/auth';

export default {
  name: "index",
  props: ['fileList', 'businessType'],
  data() {
    return {
      dialogImageUrl: '',  // 预览图片的 URL
      dialogVisible: false,  // 是否显示预览弹窗
      uploadUrl: process.env.FILE_URL + "/fileWeb/uploadResource",  // 上传接口 URL
      paramsObj: { accessToken: getToken() },  // 上传时的额外参数
    };
  },
  watch: {
    // 监听 fileList 变化，更新上传参数并重新加载资源列表
    fileList(list) {
      this.$emit('confirm', list);
    },
  },
  created() {
    // 初始化时设置上传所需的 accessToken
    this.paramsObj['accessToken'] = getToken();
    this.paramsObj['businessType'] = this.businessType;
  },
  components: {
    draggable
  },
  methods: {
    // 删除文件时的回调
    handleRemove(file) {
      this.$confirm(`确定要删除这个图片吗?`, '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
        const index = this.fileList.findIndex(f => f.resourceId === file.resourceId);
        if (index > -1) {
          this.fileList.splice(index, 1); // 从 fileList 中移除该文件
        }
        return this.request({
          method:'post',
          url:'/web/service?method=tCoreResource_delete',
          params: {'id': file.resourceId}
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$emit('confirm', this.fileList);
        })
      }).catch(() => {})



    },

    // 预览图片的回调
    handlePictureCardPreview(file) {
      this.dialogVisible = true;  // 显示弹窗
      this.dialogImageUrl = file.url;
    },

    // 上传成功时的回调
    handleSuccess(response) {
      // 如果返回的编码不为 '0'，表示上传失败，提示错误
      if (response.code != '0') {
        this.$message.error(response.msg);
        return false;
      }
      console.log(response)
      // 手动将上传成功的文件添加到 fileList
      let uploadedFile = {
        resourceId: response.resourceId,
        url:  process.env.FILE_URL + "/upload/" + response.filePath,
        fileName: response.fileName
      };

      this.fileList.push(uploadedFile);

      // this.$message.success('上传成功');
    },
  }
};
</script>

<style scoped>
  .uploadImgList-single{position: relative; display: inline-block;height: 120px;width: 120px;margin-right: 10px;margin-bottom: 10px;padding: 6px;border: 1px solid #ddd;background: #fff;}
  .uploadImgList-single .img-cover{display: block;width: 100%;height: 100%;background: no-repeat 50%/100%;}
  .uploadImgList-single .el-icon-delete{display: none;
    position: absolute;
    top: -8px;
    right: -8px;
    cursor: pointer;
    font-size: 16px;
    display: block;
    color: #c5c5c5;}
  .upload-button{display: inline;}
  /deep/.upload-button .el-upload--picture-card{height: 120px;width: 120px;line-height:120px;}
</style>



// WEBPACK FOOTER //
// src/components/XrUploadImg/index.vue